import dayjs from "dayjs";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { UserService } from "@/services";
import * as types from "@/store/types";
import { mapGetters, mapActions } from "vuex";
import $enDigits from "@/mixins/enDigits";

export default {
  name: "personal-identity",
  components: { datePicker: VuePersianDatetimePicker },
  mixins: [$enDigits],
  data() {
    return {
      isRequesting: false,
      birthDatePicker: "",
      firstNameInput: "",
      lastNameInput: "",
      nationalCodeInput: "",
      isNCHover: false,
      isNCFocus: false,
      isFirstNameFocus: false,
      isFirstNameHover: false,
      isLastNameFocus: false,
      isLastNameHover: false

      // genderInput: "",
    };
  },

  computed: {
    ...mapGetters({
      userVerifyStatus: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      isModalOpen: types.identity.getters.IS_MODAL_OPEN,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),

    firstName() {
      return this.userInfo?.first_name;
    },

    lastName() {
      return this.userInfo?.last_name;
    },

    fullName() {
      return this.userInfo?.name;
    },

    nationalCode() {
      return this.userInfo?.national_code;
    },

    // gender() {
    //   return this.userInfo?.gender;
    // },

    birthDate() {
      return this.userInfo?.birth_date;
    },

    status() {
      return this.userVerifyStatus?.personal_information_status;
    },

    isVerify() {
      return this.status === "VERIFIED";
    },

    isProcessing() {
      return this.status === "PROCESSING";
    },

    isReject() {
      return this.status === "REJECTED";
    },

    rejectReason() {
      return this.userVerifyStatus?.personal_information_reject_reason;
    },

    firstNameClass() {
      if (this.isFirstNameFocus) {
        return "mobile_name_focus";
      } else {
        if (this.firstNameInput) {
          return "mobile_name_fill";
        } else {
          if (this.isFirstNameFocus) {
            return "mobile_name_empty_hover";
          } else {
            return "mobile_name_empty";
          }
        }
      }
    },

    lastNameClass() {
      if (this.isLastNameFocus) {
        return "mobile_name_focus";
      } else {
        if (this.lastNameInput) {
          return "mobile_name_fill";
        } else {
          if (this.isLastNameFocus) {
            return "mobile_name_empty_hover";
          } else {
            return "mobile_name_empty";
          }
        }
      }
    },
    nCNameClass() {
      if (this.isNCFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isNCValid) {
          return "mobile_name_error";
        } else {
          if (this.nationalCodeInput) {
            return "mobile_name_fill";
          } else {
            if (this.isNCHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isNCValid() {
      if (this.nationalCodeInput) {
        const nCRegex = /^\d{10}$/;
        return nCRegex.test(this.nationalCodeInput);
      }
      return true;
    },

    identityModal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        this.setModal(val);
      }
    }
  },

  mounted() {
    this.firstNameInput = this.firstName;
    this.lastNameInput = this.lastName;
    this.nationalCodeInput = this.nationalCode;
    if (this.birthDate) {
      this.birthDatePicker = this.dateMethod(this.birthDate);
    }
    // this.genderInput = this.gender;
  },

  methods: {
    ...mapActions({
      setModal: types.identity.actions.SET_MODAL,
      setPersonalStatus: types.userVerifyInfo.actions.SET_PERSONAL_STATUS,
      setPersonal: types.userInfo.actions.SET_PERSONAL
    }),

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openIdentityModal() {
      this.setModal(true);
    },

    closeIdentityModal() {
      this.setModal(false);
    },

    clearBirthDatePicker() {
      this.birthDatePicker = "";
    },

    // fromDateTimestamp(date) {
    //   const UTCString = date._d.toUTCString();
    //   this.birthDateStamp = dayjs(UTCString).valueOf();
    // },

    updateInfo() {
      const data = {
        firstName: this.firstNameInput,
        lastName: this.lastNameInput,
        nationalCode: this.nationalCodeInput,
        birthDate: this.birthDatePicker
        // gender: this.genderInput
      };

      UserService.updateInfo(data)
        .then(res => {
          this.setPersonalStatus("PROCESSING");
          this.setPersonal(res.data.data);
          this.closeIdentityModal();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },

    dateMethod(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },

    setNCHover(bool) {
      this.isNCHover = bool;
    },

    toggleNCFocus() {
      this.isNCFocus = !this.isNCFocus;
    },
    checkFirstName() {
      let persianRe = /\w/g;
      this.firstNameInput = this.firstNameInput.replace(persianRe, "");
    },
    checkLastName() {
      let persianRe = /\w/g;
      this.lastNameInput = this.lastNameInput.replace(persianRe, "");
    },
    date(date) {
      return dayjs(date).format("YYYY-MM-DD");
    }
  },

  watch: {
    nationalCodeInput(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      const digitReg = /^\d+$/;
      const isDigit = digitReg.test(value);
      if (newValue) {
        if (!isDigit) {
          this.nationalCodeInput = this.$enDigits(oldValue);
        }
      }
    },

    firstName(value) {
      this.firstNameInput = value;
    },

    lastName(value) {
      this.lastNameInput = value;
    },

    nationalCode(value) {
      this.nationalCodeInput = value;
    },

    birthDate(value) {
      if (value) {
        this.birthDatePicker = this.dateMethod(value);
      }
    }
    // firstNameInput: {
    //   immediate: true,
    //   deep: true,
    //   handler(val, oldValue) {
    //     this.firstNameInput = 'val'
    //   }
    // }
  }
};

/* NC stands for National Code */
